module.exports = __webpack_public_path__ + "img/empresa_234x60.2e61a300.gif";